import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Card,
} from "reactstrap";
import { FA } from "components/FA";
import { modalService } from "services";
import styles from "./Download.module.css";

const Tab = {
  OVERVIEW: "overview",
  REQUIREMENTS: "requirements",
  INSTALL: "install",
};

const DownloadContent = ({ triggered = false, isModal, close }) => {
  const [tab, setTab] = useState(Tab.OVERVIEW);

  const handleToggle = (t) => {
    if (tab !== t) setTab(t);
  };

  const handleClick = (e, t) => {
    e.preventDefault();
    handleToggle(t);
    return false;
  };
  return (
    <>
      <h3 className="card-header">
        KnowING IPR Standalone Application{" "}
        {isModal && (
          <FA title="Close" onClick={() => close()} icon="times" size="xs" />
        )}
      </h3>
      <div className="card-body">
        <Nav tabs className={styles.nav}>
          <NavItem>
            <NavLink
              className={tab === Tab.OVERVIEW ? "active" : ""}
              onClick={() => {
                handleToggle(Tab.OVERVIEW);
              }}
            >
              Overview
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tab === Tab.REQUIREMENTS ? "active" : ""}
              onClick={() => {
                handleToggle(Tab.REQUIREMENTS);
              }}
            >
              Requirements
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={tab === Tab.INSTALL ? "active" : ""}
              onClick={() => {
                handleToggle(Tab.INSTALL);
              }}
            >
              Installation
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={tab} className={styles.content}>
          {tab === Tab.OVERVIEW && (
            <TabPane className="active">
              <h4 className="card-title">What it is</h4>
              <p className="card-text">
                The Standalone Application is a self-hosting solution of this
                application, with the additional feature to upload your own
                files to your search request.
              </p>
              <h4 className="card-title">Why use it</h4>
              <p className="card-text">
                You should use the Standalone Application if you want to:
              </p>
              <ul>
                <li>control where your data is stored</li>
                <li>use the upload feature of this Application</li>
                <li>
                  make this tool accessable within your companies intranet
                </li>
              </ul>
              <h4 className="card-title">Requirements</h4>
              <p className="card-text">
                The{" "}
                <a
                  href="/download#requirements"
                  onClick={(e) => handleClick(e, Tab.REQUIREMENTS)}
                >
                  requirements
                </a>{" "}
                show you what you need to prepare, in order to{" "}
                <a
                  href="/download#install"
                  onClick={(e) => handleClick(e, Tab.INSTALL)}
                >
                  install
                </a>{" "}
                the standalone application on your machine.
              </p>
              <h4 className="card-title">Installation Guide</h4>
              <p className="card-text">
                The{" "}
                <a
                  href="/download#install"
                  onClick={(e) => handleClick(e, Tab.INSTALL)}
                >
                  installation section
                </a>{" "}
                shows you how to install Knowing.App on any machine supporting
                Docker.
              </p>
              <h4 className="card-title">Download</h4>
              <p>
                You can download the KnowING.App{" "}
                <a
                  href="/KnowING.App.zip"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  here.
                </a>
              </p>
            </TabPane>
          )}
          {tab === Tab.REQUIREMENTS && (
            <TabPane className="active">
              <h4 className="card-title">Requirements</h4>
              <p className="card-text">
                You need the following to install the Application in your
                infrastructure:
              </p>
              <ul>
                <li>
                  installed <code>docker</code> and <code>docker-compose</code>
                </li>
                <li>Internet Access</li>
                <li>SMTP Server Credentials</li>
                <li>Public URL + SSL Certificate</li>
                <li>4 available Ports</li>
                <li>Reverse Proxy</li>
              </ul>
              <h5 className="card-subtitle">Docker</h5>
              <p className="card-text">
                Install the Docker Engine on your Machine.{" "}
                <a
                  href="https://docs.docker.com/engine/install/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Learn more
                </a>
                .
              </p>
              <p>
                <strong>Note</strong>: Make sure that your Docker Engine is
                using Linux Containers.
              </p>
              <h5 className="card-subtitle">Internet Access</h5>
              <p className="card-text">
                You need internet access to{" "}
                <a
                  href="/KnowING.App.zip"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  download
                </a>{" "}
                the <code>KnowING.App.zip</code>, the latest KnowING.App
                Container and to query the Report Generation Module in
                production. In production you only need access to{" "}
                <code>178.172.41.73:5557</code> and to google services for the
                statistical analysis.
              </p>
              <h5 className="card-subtitle">SMTP Server Credentials</h5>
              <p className="card-text">
                To send emails to your users, providing password reset links,
                account validation links a SMTP mailbox is required. You need
                the following information:
              </p>
              <ul>
                <li>Host URL</li>
                <li>Port, usually 25</li>
                <li>UserName, usually the E-Mail address</li>
                <li>Password</li>
              </ul>
              <h5 className="card-subtitle">Public URL + SSL Certificate</h5>
              <p className="card-text">
                You need a public URL with a designated SSL certificate. It can
                also be the internal Machine name/IP4 address, if you are not
                planning to expose the Standalone Application to the public.
              </p>
              <p className="card-text">
                You need the following information about your SSL certificate to
                integrate it fully into the Standalone Application:
              </p>
              <ul>
                <li>Path to your certificate files</li>
                <li>Certificate Issuer</li>
                <li>Certificate Thumbprint</li>
                <li>Certificate Password</li>
                <li>Certificate as knowing.pfx file</li>
              </ul>
              <h5 className="card-subtitle">4 available Ports</h5>
              <p className="card-text">
                If you use the default installation, you need 4 available Ports
                on your Machine. You can change them to any port you desire.
              </p>
              <ul>
                <li>
                  Application HTTP <code>5000</code>
                </li>
                <li>
                  Application HTTPS <code>5001</code>
                </li>
                <li>
                  MongoDB <code>27017</code>
                </li>
                <li>
                  SEQ <code>5341</code>
                </li>
              </ul>
              <h5 className="card-subtitle">Reverse Proxy</h5>
              <p className="card-text">
                This application is served via a Kestrel Server. If you require
                an additional layer of security, do not expose the Application
                directly but attach an NGINX or IIS reverse proxy in front of
                it. Learn more about{" "}
                <a
                  href="https://docs.microsoft.com/en-us/aspnet/core/fundamentals/servers/?view=aspnetcore-3.1&tabs=windows"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kestrel
                </a>
                ,{" "}
                <a
                  href="https://docs.microsoft.com/en-us/archive/blogs/friis/setup-iis-with-url-rewrite-as-a-reverse-proxy-for-real-world-apps"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IIS Reverse Proxy
                </a>{" "}
                or{" "}
                <a
                  href="https://docs.nginx.com/nginx/admin-guide/web-server/reverse-proxy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NGINX Reverse Proxy
                </a>
                .
              </p>
            </TabPane>
          )}
          {tab === Tab.INSTALL && (
            <TabPane className="active">
              <h4 className="card-title">Installation</h4>
              <p className="card-text">
                Follow the four steps to install the Application on your
                Machine:
              </p>
              <ol>
                <li>Download the KnowING.App.zip</li>
                <li>
                  Modify <code>.env</code> with the information you accumulated,
                  while going through the{" "}
                  <a
                    href="/download#requirements"
                    onClick={(e) => handleClick(e, Tab.REQUIREMENTS)}
                  >
                    Requirements
                  </a>
                </li>
                <li>
                  Open a terminal/commandline and go to the directory with your{" "}
                  <code>.env</code> and <code>docker-compose.yml</code> files
                </li>
                <li>
                  Run <code>docker-compose up -d</code>
                </li>
              </ol>
              <p className="card-text">
                Open a browser and navigate to your designated URL
              </p>
              <h4 className="card-title">Updating</h4>
              <p className="card-text">
                Run the following to update the Application on your Machine:
                <br />
                <code>
                  docker-compose up --force-recreate --build -d knowing.app
                </code>
              </p>
              <p className="card-text">
                Open a browser and navigate to your designated URL
              </p>
              <h4 className="card-title">Use other MongoDB/SEQ instances</h4>
              <p className="card-text">
                Remove the <code>seq</code> and <code>mongo</code> containers in
                your <code>docker-compose.yml</code>. Remove the dependencies{" "}
                <code>depends_on</code> in your <code>knowing.app</code>{" "}
                container. Modify the <code>SEQ_URL</code> and{" "}
                <code>ASPNETCORE_ConnectionStrings__MongoDbDatabase</code>{" "}
                environment variables in your <code>knowing.app</code>{" "}
                container.
              </p>
              <p className="card-text">
                <strong>Note</strong>: Use <code>host.docker.internal</code>, if
                you need to reference <code>localhost</code>
              </p>
            </TabPane>
          )}
        </TabContent>
      </div>
    </>
  );
};

const Download = ({ history }) => (
  <>
    {history.length > 2 && (
      <Button color="link" onClick={history.goBack}>
        <FA icon="angle-left" size="xs" /> back
      </Button>
    )}
    <Card className={styles.card}>
      <DownloadContent />
    </Card>
  </>
);

const openDownloadModal = (triggered = false) =>
  modalService.open({
    id: "download",
    children: (
      <DownloadContent
        triggered={triggered}
        isModal={true}
        close={() => modalService.close("download")}
      />
    ),
  });

export { Download, openDownloadModal };
